<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
/**
 * team-list component
 */

export default {
  page: {
    title: "Integrations",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      integrationData: [{
        id: '',
        name: 'Zoho',
        image: 'zoho.png',
        description: 'Integrate with ZOHO and store your screenshots in Zoho WorkDrive.',
        locale: '',
        activationlink: 'https://accounts.zoho.com/oauth/v2/auth?prompt=consent&scope=WorkDrive.users.ALL,WorkDrive.team.ALL,WorkDrive.files.ALL&client_id=1000.QMTTYD9X2B9YTML5UMHG6XI0U9OPVM&response_type=code&access_type=offline&redirect_uri=https://workrhythm.net/account&state=register',
        startTime: 0,
        status: 0, //0 -> Not done yet, 1-> Active, 2 -> Inactive
        lastModifiedTime: 0,
        isDeleted: 0,
      }],
      loader: false,
      mapData: new Map(),
    };
  },
  methods: {
    async getAllIntegrations() {
      this.loader = true;
      try {
        const response = await axios.get(
          process.env.VUE_APP_EMPLOYEE_URL + "/account/integrations",
          { params: { companyId: this.loginData.companyId } }
        );

        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            response.data.data.forEach(object => {
              this.mapData.set(object.name, object);
            });

            for (var i = 0; i < this.integrationData.length; i++) {
              let val = this.mapData.get(this.integrationData[i].name);
              if(val) {
                this.integrationData[i].id = val.id;
                this.integrationData[i].locale = val.locale;
                this.integrationData[i].startTime = val.startTime;
                this.integrationData[i].status = val.status;
                this.integrationData[i].lastModifiedTime = val.lastModifiedTime;
                this.integrationData[i].isDeleted = val.isDeleted;
              }
            }
          }
        }
      } catch (error) {
       // console.log(error);
      }
      this.loader = false;
    },
    async changeIntegrationActivity(name, val) {
        let formData = new FormData();
        formData.append("companyId", this.loginData.companyId);
        formData.append("name", name);
        formData.append("status", val);

        axios
          .post(process.env.VUE_APP_EMPLOYEE_URL + `/account/change_integration_status`, formData)
          .then((res) => {
            if(res.data.success == "true") {
              Swal.fire({
                title: "Success",
                text: "Request Successfully Executed.",
                icon: 'success',
                onClose: () => {
                  this.getAllIntegrations();
                }
              });
            } else {
              Vue.swal(res.data);
            }
            return res;
          })
          .catch((err) => {
            Vue.swal("Oops! Some error occured.");
            return err;
          });
    },
  },
  created() {
    this.loginData = JSON.parse(localStorage.getItem('user'));
    this.getAllIntegrations();
  },
  mounted() {
    //console.log(this.$route.query);
  },
  computed: {
    searchevents: function() {
      var result = this.teams;
      if (!this.filterValue)
        return result;
      
      const filterValue = this.filterValue.toLowerCase();

      const filter = event => 
          event.teamName.toLowerCase().includes(filterValue);
      
      return result.filter(filter);
    },
  },
  
};
</script>

<template>
  <Layout>
    <PageHeader :title="'Integrations'" />
    <div class="row">
      <div class="col-lg-6 col-xl-3">
          <b-card v-for="(src, index) in integrationData" :key="index" :img-src="require('@/assets/images/' + src.image)" :img-alt="src.image" class="p-2" img-top>
              <b-card-title>
                  <h5 class="card-title mt-2">{{ src.name }}</h5>
              </b-card-title>
              <b-card-text>
                  {{ src.description }}
              </b-card-text>
              <div v-if="loader == false">
                <a v-if="src.status == 0" class="btn btn-primary" :href="src.activationlink" target="_blank" variant="primary">Proceed</a>
                <b-dropdown v-if="src.status == 1" split text="Active" class="m-2" variant="success">
                    <b-dropdown-item :href="src.activationlink" target="_blank">Integrate Other Account</b-dropdown-item>
                    <b-dropdown-item href="#" @click="changeIntegrationActivity(src.name, 2)">Revoke</b-dropdown-item>
                </b-dropdown>
                <b-dropdown v-if="src.status == 2" split text="Inactive" class="m-2" variant="danger">
                    <b-dropdown-item :href="src.activationlink" target="_blank">Integrate Other Account</b-dropdown-item>
                    <b-dropdown-item href="#" @click="changeIntegrationActivity(src.name, 1)">Re-Activate</b-dropdown-item>
                </b-dropdown>
              </div>
              <div v-else>
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </div>
          </b-card>
      </div>
    </div>

  </Layout>
</template>
<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  width: 100%;
  background-color: #fff;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
.parent {
  position: relative;
  top: 0;
  left: 0;
}
.image1 {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
}
.image2 {
  position: absolute;
  z-index: 2;
  border: 29px solid #000000;
  border-radius: 24px;
}
@media (min-height: 768px) {
  .img-card-height {
    height: 540px;
  }
}
@media (min-height: 769px) {
  .img-card-height {
    height: calc(100vh - 143px - 275px);
  }
}
@media only screen and (min-width: 1200px) {
.img-card {
    width: calc(100% - 90px);
      top: 36px;
      left: 39px;
}
}
@media only screen and (max-width: 1200px) {
.img-card {
    width: calc(100% - 70px);
    top: 36px;
    left: 29px;
}
}
@media only screen and (max-width: 991px) {
.img-card {
    width: calc(100% - 54px);
    top: 36px;
    left: 21px;
}
}
</style>